import { observer } from 'mobx-react-lite'
import { FC, useContext } from 'react'
import { Context } from '..'

import styles from '../styles/Acceptance.module.scss'
import { LOCALES } from '../core/i18n/locales'
import AcceptPartnerEnglish from './AcceptPartnerEnglish'

const AcceptPartner: FC = () => {
	const { store } = useContext(Context)

	if (store.locale === LOCALES.ENGLISH) {
		return <AcceptPartnerEnglish />
	}

	return (
		<>
			<div className={styles.policy}>
				<div className='container'>
					<div className='row'>
						<div className='col-12'>
							<div className={styles.wrapper}>
								<h1>ПАРТНЕРСКОЕ СОГЛАШЕНИЕ</h1>
								<h2>(договор публичной оферты)</h2>
								<h3>PODCASTBERY</h3>
								<p className={styles.addr}>
									Дата вступления в силу: 26.01.2026
									<br />
									г. Москва редакция от 18.06.2026
								</p>

								<p>
									Настоящий документ представляет собой предложение (публичную оферту) Индивидуального
									предпринимателя Казанцевой Виктории Александровны (ИНН 245211492400, ОГРИП
									326246800097782) (далее — «<b>Оператор</b>») заключить договор на условиях,
									изложенных в настоящем документе (далее — «<b>Оферта</b>»), с любым лицом, которое
									осуществит ее акцепт в соответствии с разделом 1.3 настоящей Оферты.
								</p>

								<p>
									<b>ОСНОВНЫЕ ПОНЯТИЯ</b>
								</p>
								<p>
									<b>Акцепт Оферты</b> — совершение Поставщиком совокупности действий, предусмотренных
									п. 1.3 настоящей Оферты для выбранного тарифного плана, означающее полное и
									безоговорочное принятие всех условий Оферты и документов, указанных в п. 1.4.
								</p>
								<p>
									<b>Договор</b> — договор между Оператором и Поставщиком, заключенный путем акцепта
									настоящей Оферты, на условиях выбранного тарифного плана.
								</p>
								<p>
									<b>Поставщик (Студия)</b> — юридическое лицо или индивидуальный предприниматель,
									осуществившие Акцепт настоящей Оферты в соответствии с выбранным тарифным планом.
								</p>
								<p>
									<b>Услуги Поставщика</b> — услуги по предоставлению в почасовую аренду Залов для
									создания аудио- и видеоконтента, а также иные дополнительные услуги, оказываемые
									Поставщиком Заказчику.
								</p>
								<p>
									<b>Зал</b> — пространство, информация о котором предоставлена Поставщиком и
									размещена Оператором на Сайте.
								</p>
								<p>
									<b>Сайт (Сервис)</b> — информационный ресурс Оператора в сети Интернет,
									расположенный по адресу{' '}
									<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>.
								</p>
								<p>
									<b>Заказчик</b> — лицо, обратившееся к Оператору или Поставщику с намерением
									забронировать Зал Поставщика.
								</p>
								<p>
									<b>Тарифный план (Тариф)</b> — один из пакетов услуг Оператора («Standart», «PRO»,
									«Premium»), определяющий объем прав и обязанностей Сторон, порядок взаимодействия и
									расчетов. Детальные условия тарифов изложены в п. 2.5 настоящей Оферты и в
									Приложении №2 (Тарифы), являющемся ее неотъемлемой частью.
								</p>
								<p>
									<b>Личный кабинет</b> — защищенный раздел Сайта, доступный Поставщикам на тарифах
									«PRO» и «Premium» для управления информацией, заказами и взаимодействия с
									Оператором.
								</p>
								<p>
									<b>Заказ</b> — должным образом оформленный запрос Заказчика на получение Услуг
									Поставщика.
								</p>

								<p>
									<b>1. ОБЩИЕ ПОЛОЖЕНИЯ</b>
								</p>
								<p>
									<b>1.1.</b> Настоящая Оферта регулирует взаимоотношения Сторон в рамках выбранного
									Поставщиком тарифного плана: «Standart», «PRO» или «Premium». Условия и функционал
									каждого тарифа различны и детализированы в соответствующих разделах Оферты и в
									Приложении №2.
								</p>
								<p>
									<b>1.2.</b> Настоящая Оферта является публичной офертой в соответствии со ст. 435 и
									п. 2 ст. 437 Гражданского кодекса Российской Федерации (ГК РФ). Акцепт Оферты в
									порядке, указанном в п. 1.3, означает заключение Договора на условиях, изложенных в
									Оферте.
								</p>
								<p>
									<b>1.3.</b> Полным и безоговорочным акцептом (принятием) условий настоящей Оферты
									считается последовательное выполнение Поставщиком следующих действий для
									соответствующего тарифа:
									<br />
									Для всех тарифов:
									<br />
									1.3.1. Заполнение регистрационной формы на Сайте с предоставлением запрашиваемых
									данных о Поставщике и Зале.
									<br />
									1.3.2. Направление Оператору на электронный адрес info@podcastbery.ru копий
									документов для модерации (свидетельства ОГРН/ОГРИП, документа, подтверждающего право
									пользования помещением).
									<br />
									<br />
									Дополнительно для тарифа «Standart»:
									<br />
									1.3.3. Получение от Оператора уведомления об успешной модерации и публикации
									карточки Зала в каталоге Сайта.
									<br />
									<br />
									Дополнительно для тарифа «PRO»:
									<br />
									1.3.4. Получение от Оператора доступа к Личному кабинету после успешной модерации.
									<br />
									1.3.5. Завершение наполнения карточки Зала в Личном кабинете в соответствии с
									требованиями п. 2.2.2 Правил сервиса в течение 7 (семи) календарных дней.
									<br />
									<br />
									Дополнительно для тарифа «Premium»:
									<br />
									1.3.6. Выбор и оплата абонентской платы за выбранный расчетный период (месяц,
									квартал, год) в соответствии с актуальным прайсом, опубликованным на Сайте.
									<br />
									1.3.7. Получение от Оператора доступа к Личному кабинету после успешной модерации и
									оплаты.
									<br />
									1.3.8. Завершение наполнения карточки Зала в Личном кабинете в соответствии с
									требованиями п. 2.2.2 Правил сервиса в течение 7 (семи) календарных дней.
								</p>
								<p>
									<b>1.4.</b> Акцептуя Оферту, Поставщик подтверждает, что он полностью ознакомился,
									понимает и безоговорочно принимает:
									<br />
									условия настоящей Оферты;
									<br />
									Правила сервиса Podcastbery, которые являются неотъемлемой частью Договора;
									<br />
									Политику конфиденциальности, размещенную на Сайте;
									<br />
									условия Тарифов, изложенные в Приложении №2 к настоящей Оферте.
								</p>
								<p>
									<b>1.5.</b> К отношениям Сторон применяется законодательство Российской Федерации.
								</p>

								<p>
									<b>2. ПРЕДМЕТ ДОГОВОРА. ПОРЯДОК ПОДКЛЮЧЕНИЯ</b>
								</p>
								<p>
									<b>2.1.</b> По настоящему Договору Оператор обязуется оказывать Поставщику услуги по
									продвижению его Зала и организации взаимодействия с Заказчиками в объеме,
									соответствующем выбранному тарифному плану, а Поставщик обязуется соблюдать условия
									Договора и, для тарифов «PRO» и «Premium», выплачивать Оператору вознаграждение.
								</p>
								<p>
									<b>2.2.</b> Подключение к Сервису осуществляется в порядке, предусмотренном п. 1.3
									настоящей Оферты.
								</p>
								<p>
									<b>2.3. Условия для тарифа «Standart»:</b>
									<br />
									2.3.1. Оператор размещает на Сайте в общем каталоге предоставленную Поставщиком
									информацию о Зале в урезанном формате (до 3 фотографий, название, базовый прайс,
									контактные данные). Прямые контакты Поставщика (телефон, email) публикуются.
									<br />
									2.3.2. Оператор не оказывает услуг по приему, обработке заявок, бронированию или
									приему платежей. Все взаимодействие с Заказчиками, консультации, согласование
									условий, подтверждение бронирования и прием оплаты Поставщик осуществляет
									самостоятельно и напрямую.
									<br />
									2.3.3. Доступ к Личному кабинету не предоставляется. Обновление информации в
									карточке возможно не чаще 1 раза в 6 месяцев по запросу на info@podcastbery.ru.
									<br />
									2.3.4. Сотрудничество на тарифе «Standart» является безвозмездным для Поставщика.
									<br />
									2.3.5. Заказчики, заинтересованные в бронировании Зала Поставщика, связываются с
									Поставщиком напрямую, используя контактные данные (телефон, email), опубликованные в
									карточке Поставщика на Сайте.
									<br />
									2.3.6. Обязанности Поставщика при работе с клиентами. Поставщик обязуется:
									обеспечить актуальность контактных данных, указанных в карточке; обеспечить
									профессиональный и своевременный ответ на обращения Заказчиков, поступившие по
									опубликованным контактам; самостоятельно определять и согласовывать с Заказчиком все
									условия оказания услуг (дата, время, стоимость, состав услуг, правила отмены и
									переноса).
								</p>
								<p>
									<b>2.4. Условия для тарифа «PRO»:</b>
									<br />
									2.4.1. Оператор предоставляет Поставщику доступ к Личному кабинету и расширенному
									функционалу, включая систему онлайн-бронирования и CRM.
									<br />
									2.4.2. На карточке Поставщика публикуется специальный номер телефона контакт-центра
									Оператора. Оператор осуществляет первичный прием и обработку запросов от Заказчиков,
									консультирует и передает заявки Поставщику для дальнейшей детальной обработки и
									подтверждения.
									<br />
									2.4.3. Оператор обеспечивает прием онлайн-платежей от Заказчиков через Сервис.
									<br />
									2.4.4. Вознаграждение Оператора составляет агентское вознаграждение (комиссию) в
									размере 20% от итоговой стоимости каждого завершенного Заказа (кроме услуг
									видеомонтажа и обработки звука, за которые комиссия составляет 10%).
									<br />
									2.4.5. Оператор перечисляет Поставщику средства, полученные от Заказчиков, за
									вычетом своего вознаграждения, в течение 2 (двух) рабочих дней после даты оказания
									услуги.
								</p>
								<p>
									<b>2.5. Условия для тарифа «Premium»:</b>
									<br />
									2.5.1. Оператор предоставляет Поставщику полный доступ к функционалу Личного
									кабинета, включая приоритетное продвижение в каталоге.
									<br />
									2.5.2. Поставщик вправе размещать в карточке свои прямые контактные данные.
									Взаимодействие с Заказчиками, консультирование, подтверждение бронирования Поставщик
									осуществляет самостоятельно.
									<br />
									2.5.3. Оператор не взимает агентское вознаграждение с Заказов.
									<br />
									2.5.4. Вознаграждение Оператора состоит из абонентской платы (подписки),
									оплачиваемой Поставщиком авансом за выбранный период. Размер платы определяется
									действующим прайсом на Сайте.
									<br />
									2.5.5. Подключается функция Автопродления. Денежные средства за следующий период
									списываются автоматически за 3 (три) календарных дня до окончания текущего
									оплаченного периода.
									<br />
									2.6. Детальная сравнительная таблица условий тарифов приведена в Приложении №2,
									которое является неотъемлемой частью настоящей Оферты.
								</p>

								<p>
									<b>3. ПРАВА И ОБЯЗАННОСТИ СТОРОН</b>
								</p>
								<p>
									<b>3.1. Оператор обязуется:</b>
									<br />
									3.1.1. Обеспечивать техническую работоспособность Сайта и его функционала в объеме,
									предусмотренном выбранным тарифом.
									<br />
									3.1.2. Осуществлять модерацию предоставленной Поставщиком информации и документов.
									<br />
									3.1.3. Размещать и поддерживать карточку Поставщика на Сайте в соответствии с
									условиями тарифа.
								</p>
								<p>
									<b>3.2. Оператор вправе:</b>
									<br />
									3.2.1. В одностороннем порядке изменять условия настоящей Оферты, Правил сервиса и
									тарифов, уведомляя Поставщика путем публикации новой редакции на Сайте не менее чем
									за 10 (десять) календарных дней до вступления изменений в силу.
									<br />
									3.2.2. Отказать в публикации, удалить карточку или приостановить доступ к Личному
									кабинету при нарушении Поставщиком условий Договора, предоставлении недостоверных
									данных или по другим основаниям, указанным в Правилах сервиса.
									<br />
									3.2.3. Взимать с Поставщика на тарифе «PRO» агентское вознаграждение, а на тарифе
									«Premium» — абонентскую плату, в установленном размере и порядке.
								</p>
								<p>
									<b>3.3. Поставщик обязуется:</b>
									<br />
									3.3.1. Предоставлять достоверную, полную и актуальную информацию о себе и Зале.
									<br />
									3.3.2. Соблюдать условия Договора, Правил сервиса и законодательства РФ.
									<br />
									3.3.3. Для тарифов «PRO» и «Premium»: своевременно и в полном объеме заполнять и
									обновлять информацию в Личном кабинете, оперативно обрабатывать заявки, изменять
									статусы Заказов.
									<br />
									3.3.4. Не предпринимать действий, направленных на обход Сервиса с целью уклонения от
									выплаты вознаграждения Оператору (для тарифа «PRO»).
									<br />
									3.3.5. Нести полную ответственность перед Заказчиком за качество и своевременность
									оказания Услуг.
								</p>
								<p>
									<b>3.4. Поставщик вправе:</b>
									<br />
									3.4.1. Использовать функционал Сервиса в объеме, предусмотренном выбранным тарифом.
									<br />
									3.4.2. Получать консультации по работе Сервиса у поддержки Оператора.
									<br />
									3.4.3. Отказаться от сотрудничества, направив письменное уведомление Оператору, в
									порядке, предусмотренном разделом 7.
								</p>

								<p>
									<b>4. ПОРЯДОК ВЗАИМОРАСЧЕТОВ</b>
								</p>
								<p>
									<b>4.1.</b> Финансовые взаимоотношения Сторон регулируются положениями раздела 2
									настоящей Оферты (для каждого тарифа) и детализируются в разделе 4 Правил сервиса.
								</p>
								<p>
									<b>4.2.</b> Для тарифа «PRO» расчеты осуществляются за каждый Заказ. Оператор
									перечисляет Поставщику средства за вычетом своего вознаграждения в сроки, указанные
									в п. 2.4.4.
								</p>
								<p>
									<b>4.3.</b> Для тарифа «Premium» Поставщик оплачивает абонентскую плату авансом.
									Возврат средств при досрочном отказе осуществляется пропорционально
									неиспользованному времени согласно шкале возврата (п. 4.12.2.3 Правил сервиса), за
									исключением периода в 30 дней, оплата за который возврату не подлежит.
								</p>
								<p>
									<b>4.4.</b> Все споры по расчетам разрешаются на основании ежемесячных отчетов,
									формируемых Оператором в Личном кабинете. Отчет считается согласованным при
									отсутствии мотивированных возражений Поставщика в течение 10 рабочих дней.
								</p>

								<p>
									<b>5. СРОК ДЕЙСТВИЯ, ИЗМЕНЕНИЕ И РАСТОРЖЕНИЕ</b>
								</p>
								<p>
									<b>5.1.</b> Договор вступает в силу с момента Акцепта Поставщиком (п. 1.3) и
									действует до его расторжения.
								</p>
								<p>
									<b>5.2.</b> Поставщик вправе расторгнуть Договор в одностороннем порядке, направив
									Оператору письменное уведомление на email info@podcastbery.ru:
									<br />
									Для тарифа «Standart» — карточка удаляется в течение 5 рабочих дней.
									<br />
									Для тарифа «PRO» — доступ к Личному кабинету прекращается в течение 5 рабочих дней
									после исполнения всех финансовых обязательств.
									<br />
									Для тарифа «Premium» — уведомление должно быть направлено не позднее чем за 24 часа
									до даты следующего автоматического списания (при отключенном автопродлении — в любое
									время). Возврат средств осуществляется в соответствии со шкалой возврата, указанной
									в п. 4.12.2.3 Правил сервиса.
								</p>
								<p>
									<b>5.3.</b> Оператор вправе расторгнуть Договор в одностороннем внесудебном порядке
									немедленно в случае существенного нарушения Поставщиком условий Договора, в том
									числе, но не ограничиваясь, нарушениями, указанными в разделе 6 и 8 Правил сервиса.
								</p>
								<p>
									<b>5.4.</b> Изменение Оператором условий Оферты осуществляется в порядке,
									предусмотренном п. 3.2.1. При несогласии с изменениями Поставщик обязан прекратить
									использование Сервиса в порядке, предусмотренном п. 5.2.
								</p>

								<p>
									<b>6. ОТВЕТСТВЕННОСТЬ</b>
								</p>
								<p>
									<b>6.1.</b> За неисполнение или ненадлежащее исполнение обязательств по Договору
									Стороны несут ответственность в соответствии с законодательством РФ и условиями
									Договора, включая положения настоящего раздела и раздела 6 Правил сервиса.
								</p>
								<p>
									<b>6.2. Ответственность Поставщика:</b>
									<br />
									6.2.1. <b>За срыв Заказа:</b> В случае срыва Поставщиком подтвержденного Заказа по
									своей вине, Поставщик обязан выплатить Оператору штраф в размере 1 000 (одна тысяча)
									рублей, а также агентское вознаграждение (для тарифа «PRO») в полном размере, как
									если бы Заказ был выполнен (п. 6.1.1 Правил сервиса).
									<br />
									6.2.2. <b>За обход Сервиса:</b> В случае если после получения запроса/бронирования
									через Сервис Поставщик и Заказчик заключают соглашение на оказание тех же услуг
									напрямую, минуя Сервис, и Поставщик умышленно не уведомил Оператора, Поставщик
									обязан уплатить Оператору:
									<br />
									a) Агентское вознаграждение в двойном размере от стоимости Заказа;
									<br />
									b) Штраф в размере 20% от стоимости такого Заказа.
									<br />
									Оператор также вправе расторгнуть Договор в одностороннем внесудебном порядке (п.
									6.9.1 Правил сервиса).
									<br />
									6.2.3. <b>За сокрытие суммы Заказа:</b> В случае умышленного сокрытия Поставщиком от
									Оператора полной стоимости Заказа с целью уменьшения суммы агентского
									вознаграждения, Поставщик обязан уплатить штраф в размере двойной суммы сокрытого
									вознаграждения, а Оператор вправе расторгнуть Договор (п. 6.9.4 Правил сервиса).
									<br />
									6.2.4. <b>За просрочку платежа:</b> В случае нарушения сроков перечисления комиссии
									Оператору Поставщик уплачивает пеню в размере 0,1% от неуплаченной суммы за каждый
									день просрочки, но не более 10% от такой суммы (п. 5.3 Договора о сотрудничестве).
									<br />
									6.2.5. <b>За наложение броней:</b> В случае непредставления Поставщиком Зала
									Заказчику в забронированные часы по вине Поставщика (наложение броней), Поставщик
									выплачивает Оператору штраф в размере 1 000 (одна тысяча) рублей за каждый случай
									(п. 6.1 Правил сервиса).
									<br />
									6.2.6. Поставщик несет полную ответственность перед Заказчиком за качество и
									своевременность оказания Услуг, а также возмещает Оператору все убытки, понесенные в
									связи с претензиями третьих лиц, вызванными действиями Поставщика.
								</p>
								<p>
									<b>6.3. Ответственность Оператора:</b>
									<br />
									6.3.1. Оператор несет ограниченную ответственность перед Поставщиком. В случае
									неработоспособности Сайта, повлекшей срыв бронирований по вине Оператора,
									ответственность Оператора ограничивается суммой агентского вознаграждения за такие
									сорванные бронирования (п. 6.5 Правил сервиса).
									<br />
									6.3.2. Оператор не несет ответственности за:
									<br />
									a) убытки Поставщика, возникшие в связи с использованием Сервиса или взаимодействием
									с Заказчиками;
									<br />
									b) неисполнение обязательств между Поставщиком и Заказчиком;
									<br />
									c) достоверность информации, предоставленной Поставщиком или Заказчиками.
								</p>
								<p>
									<b>6.4. Меры оперативного воздействия:</b>
									<br />
									За систематические нарушения (несвоевременное обновление статусов, сокрытие
									информации и пр.) Оператор вправе применять к Поставщику меры, включая понижение в
									поисковой выдаче, принудительное изменение тарифа или удаление карточки (п. 3.7.2
									Правил сервиса).
								</p>

								<p>
									<b>7. ПРОЧИЕ УСЛОВИЯ</b>
								</p>
								<p>
									<b>7.1.</b> Договор вступает в силу с момента Акцепта Поставщиком (п. 1.3) и
									действует до удаления карточки Поставщика из каталога.
								</p>
								<p>
									<b>7.2.</b> Признание судом какого-либо положения Договора недействительным не
									влечет недействительности остальных положений.
								</p>
								<p>
									<b>7.3.</b> Все споры подлежат разрешению в суде по месту нахождения Оператора.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default observer(AcceptPartner)
